<script setup lang="ts">
import { OptionMain, productInfoKey } from '~/lib/services/store/catalog/catalog.dtos'

const props = defineProps<{
  options: OptionMain[]
}>()

const emit = defineEmits<{
  (e: 'close-choice'): void
}>()

const { t } = useLocale()
const { trackSelectComponent } = useGTM()
const productInfo = inject(productInfoKey)!

const showingHiddenOptions = ref(false)

const availableOptions = computed(() => props.options.filter(opt => opt.available))
const hiddenOptions = computed(() => availableOptions.value.filter(opt => opt.hide))
const showedOptions = computed(() => availableOptions.value.filter(opt => !opt.hide))

const getMinAmountPrice = (options: OptionMain[]) => {
  let amount = 0
  options.forEach((opt, index) => {
    if (index === 0) amount = opt.price.amount
    else if (opt.price.amount < amount) amount = opt.price.amount
  })
  return amount
}

// minAmount to show price on every row or not
const minAmount = computed(() => getMinAmountPrice(availableOptions.value))

const isOptionSelected = (opt: OptionMain) => opt.qty === 1
const selectOption = (opt: OptionMain) => {
  availableOptions.value.forEach(option => {
    if (option.identifier === opt.identifier) option.qty = 1
    else option.qty = 0
  })
  opt.qty = 1
  trackSelectComponent(productInfo, { id: opt.identifier, name: opt.name })
  emit('close-choice')
}

onMounted(() => {
  // Not show first option which is already selected
  if (props.options.length === 1 && isOptionSelected(props.options[0])) emit('close-choice')
})
</script>

<template>
  <!-- On first show options -->
  <ChoiceOption
    v-for="opt in showedOptions"
    :key="opt.identifier"
    :option="opt"
    :min-group-amount="minAmount"
    @select-option="selectOption"
  />

  <!-- Hidden on first show options -->
  <div v-if="hiddenOptions.length">
    <McdButton
      v-if="!showingHiddenOptions"
      class="mt-2 w-full border-0 border-t border-t-mcd-black p-4 md:mx-auto md:w-fit md:border md:p-2"
      @on-click="showingHiddenOptions = true"
    >
      {{ t('common.seeMore') }}
    </McdButton>

    <ChoiceOption
      v-for="opt in hiddenOptions"
      v-else
      :key="opt.identifier"
      :option="opt"
      :min-group-amount="minAmount"
      @select-option="selectOption"
    />
  </div>
</template>
